import React from 'react'
import axios from 'axios'

import Button from '../Form/Button'

export default class MensagemFiscal extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			loaded: false,
			list: [],
			ficha: {
				usuario: localStorage.nome,
			}
		}
	}

	componentDidMount() {
		const url = '/api/mensagem/getMensagem'
		const fiscal = this.state.ficha
		axios.post(url, fiscal)
			.then(resp => {
				this.setState({ loaded: true })
				this.setState({ list: resp.data.mensagens })
			})
			.catch(error => {
				alert(error)
			}
			)
	}

	arquivar(id) {
		const url = '/api/mensagem/arquivarMensagem'
		axios.post(url, { id, user: localStorage.nome })
			.then(window.location = '/mensagemFiscal')
			.catch(error => {
				alert(error)
			})
	}

	render() {
		if (this.state.loaded) {
			return (
				<React.Fragment>
					<div className="container mx-auto">
						{this.renderMensagens()}
					</div>
				</React.Fragment>
			)
		} else {
			return <div></div>
		}
	}

	renderMensagens() {
		if (this.state.loaded) {
			const mensagens = this.state.list.reverse()
			return mensagens.map(mensagem => {
				let ano = mensagem.data.slice(0, 4)
				let mes = mensagem.data.slice(5, 7)
				let dia = mensagem.data.slice(8, 10)
				let data = dia + "/" + mes + "/" + ano
				return (
					<React.Fragment>
						<div className="form-group row text-left">
							<label className="col-3 col-md-2 mt-3">Usuário:</label>
							<div className="col-9 col-md-4 mb-3 mt-3">
								<input type="text" className="form-control"
									value={mensagem.usuario} />
							</div>
							<label className="col-3 col-md-2 mt-3">Data:</label>
							<div className="col-9 col-md-4 mb-3 mt-3">
								<input type="text" className="form-control"
									value={data} />
							</div>
							<div className="form-control textarea text-left">{mensagem.texto}</div>
						</div>
						<button className="btn btn-danger mt-2"
							onClick={e => this.arquivar(mensagem._id)}>Arquivar</button>
						<hr />
					</React.Fragment>
				)
			})
		}
	}
}